import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { Module } from "types/generated";
import { hasAtLeastReadAccess } from "utils/access";

// FYI: the "module.canWrite" check here is for legacy stacks (could be affected by access policies)
const useHasModuleReadAccess = (): ((module?: Module) => boolean) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (module?: Module) => {
      if (!module) {
        return false;
      }

      if (viewer.admin) {
        return true;
      }

      if (module.canWrite) {
        return true;
      }

      return hasAtLeastReadAccess(viewer, module.spaceDetails?.id || module.space);
    },
    [viewer]
  );
};

export default useHasModuleReadAccess;
